module.exports = __webpack_public_path__ + "img/nbusbottom.e976aaf1.jpg";